/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto } from '../models/Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto';
import type { Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto } from '../models/Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto';
import type { Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto } from '../models/Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto';
import type { Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto } from '../models/Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_HoldingSummaryOutputDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_HoldingSummaryOutputDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto';
import type { Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto } from '../models/Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardAppSharedService {

    /**
     * @returns Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantDashboard(): CancelablePromise<Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantTask(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-task',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantUpcomingEvents(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-upcoming-events',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardVestingSchedule(): CancelablePromise<Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/vesting-schedule',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantHoldingDetails(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-holding-details',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_HoldingSummaryOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantHoldingSummary(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_HoldingSummaryOutputDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-holding-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantTaskSummary(): CancelablePromise<Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-task-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantUpcomingEventsSummary(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-upcoming-events-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardAppSharedParticipantTradePreClearance(): CancelablePromise<Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard-app-shared/participant-trade-pre-clearance',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardAppSharedParticipantHoldingDetailsV1(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard-app-shared/participant-holding-details-v1',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantHoldingDetailsV2(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-holding-details-v2',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
